import { render, staticRenderFns } from "./NewNewHomeOwners.vue?vue&type=template&id=6ef5689a&"
import script from "./NewNewHomeOwners.vue?vue&type=script&lang=js&"
export * from "./NewNewHomeOwners.vue?vue&type=script&lang=js&"
import style0 from "./NewNewHomeOwners.vue?vue&type=style&index=0&id=6ef5689a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports